var displayMessage = require('./displayMessage');

function createTimeout(vueApp, timeoutTime) {
    return setTimeout( () => {
        // Log out the user
        vueApp.$store.commit('setUser', {'decoded': null, 'jwtToken': null, 'roles': null, 'runningTimeout': null})

        // if user is on the users page, redirect him to the main page
        var currentPath = vueApp.$router.currentRoute.path
        if (currentPath == '/users') {
            vueApp.$router.push('/') 
        }

        // display the timeout message
        displayMessage.display(vueApp, vueApp.$t('timeoutMessage'), vueApp.$t('close'), true)
    }, timeoutTime);
}

module.exports = {
    createTimeout : createTimeout,
}


// WEBPACK FOOTER //
// ./src/timeoutHandler.js